import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = ['The 72-Hour Rapid Reset eBook (Step-by-step Day 1, 2, and 3 guides)', 'The "Cooked-Only" Green Protocol Meal Plan', 'The 2-Minute Morning Lymphatic Drain Tutorial', 'The 72-Hour Grocery Audit & "Trigger" List', 'The "Posture Hack" for an immediate visual slimming effect', 'The Dining-Out Survival Guide for Australian Pubs & Cafes'];
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-110">
      <FadeIn data-id="element-111">
        <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-10 text-center leading-tight" data-id="element-112">
          What You Get
        </h2>

        <div className="grid gap-4" data-id="element-113">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-114">
              <div className="flex items-center gap-4 p-5 bg-cream-dark rounded-xl border border-sage/20" data-id="element-115">
                <div className="flex-shrink-0" data-id="element-116">
                  <div className="w-6 h-6 rounded-full bg-sage/20 flex items-center justify-center" data-id="element-117">
                    <Check className="w-4 h-4 text-sage-dark" data-id="element-118" />
                  </div>
                </div>
                <p className="font-sans text-charcoal font-medium" data-id="element-119">{item}</p>
              </div>
            </FadeIn>)}
        </div>
      </FadeIn>
    </section>;
}